import React from "react"
import { Box, BoxProps, styled } from "@mui/material"

type Props = {
  src: string
  alt: string
  title?: string
} & BoxProps

const ImageComponent = styled((props: Props) => (
  <Box component="img" {...props} />
))(() => ({}))

export default ImageComponent
